import { types } from '@actions/introMessages';
import StyledTextField from '@atoms/TextField';
import _ from 'lodash';

export const initialState = {
  data: [],
  audioMessageFile: {},
  isFetching: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_INTRO_MESSAGES.REQUEST: {
      return { ...state };
    }
    case types.GET_INTRO_MESSAGES.SUCCESS: {
      const { data } = action.payload;
      return { ...state, data };
    }
    case types.GET_INTRO_MESSAGES.FAILURE: {
      return { ...state, data: [] };
    }
    case types.CREATE_INTRO_MESSAGE.REQUEST: {
      const audioMessageFileName = _.get(action, 'payload.audioMessageFile.name', '');
      if (audioMessageFileName) {
        return { ...state, isFetching: true };
      }
      return { ...state };
    }

    // TODO: investigate please, do we need this, how we can refactor it.
    case types.CREATE_INTRO_MESSAGE.SUCCESS: {
      const { data } = action.payload;
      if (data.originalFileName) {
        return {
          ...state,
          data: [...state.data, { ...data }],
          isFetching: false,
          audioMessageFile: {},
        };
      }
      return { ...state, data: [...state.data, { ...data }] };
    }
    case types.SET_INTRO_MESSAGE_AUDIO: {
      return {
        ...state,
        audioMessageFile: action.file,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/introMessages.js